// extracted by mini-css-extract-plugin
module.exports = {"container":"Work_container__DVgvl","title":"Work_title__POaRk","link":"Work_link__284Yl"};